import React from "react";
import { Wrapper } from "./style";

const QuestionFormDropdown = (props: any) => {
  return <Wrapper {...props} />;
};

export default QuestionFormDropdown;
